import setupOurFarmer from '@/api/website/setup-our-farmers'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employee: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEE(state, data) {
    state.employee = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return setupOurFarmer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return setupOurFarmer.store(data)
  },
  update(context, { id, data }) {
    return setupOurFarmer.update(id, data)
  },
  destroy(context, id) {
    return setupOurFarmer.destroy(id)
  },

  async getEmployee(context, attributes = {}) {
    let response = await setupOurFarmer.employee({
      params: attributes
    })
    context.commit('SET_EMPLOYEE', response.data)
  }
}
